import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import Footer from '../Components/Footer/Footer'
import Login from '../Components/Login/Login'

const LoginComp = () => {
  return (
    <div>
        <NavBar/>
        <Login/>
        <Footer/>
      
    </div>
  )
}

export default LoginComp
